import React, { createContext, useContext, useState, useCallback } from 'react';

interface CardHeightContextType {
  maxHeight: number;
  updateMaxHeight: (height: number) => void;
}

const CardHeightContext = createContext<CardHeightContextType>({
  maxHeight: 0,
  updateMaxHeight: () => {},
});

export function CardHeightProvider({ children }: { children: React.ReactNode }) {
  const [maxHeight, setMaxHeight] = useState(0);

  const updateMaxHeight = useCallback((height: number) => {
    setMaxHeight(prev => Math.max(prev, height));
  }, []);

  return (
    <CardHeightContext.Provider value={{ maxHeight, updateMaxHeight }}>
      {children}
    </CardHeightContext.Provider>
  );
}

export const useCardHeight = () => useContext(CardHeightContext);